module.exports = __webpack_public_path__ + "img/1434888447.17048907.jpg";